import { cn as e } from "../shared/utils.js";
import { Popover as t } from "../popover/primitive/index.js";
import { PassiveTooltip as n } from "../tooltip/passive-tooltip.js";
import { HelpCircleIcon as r } from "@systemeio/icons";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/hint/hint.tsx
var o = 300, s = 100, c = e("text-icon-secondary data-popup-open:text-icon-accent", "transition-base focus-visible:focus-ring-primary", "flex shrink-0 items-center justify-center rounded-full outline-none"), l = e("text-text-secondary px-3 py-2 text-base font-normal", "origin-(--transform-origin) transition-base transition-[opacity,transform]", "data-starting-style:opacity-0 data-ending-style:opacity-0", "data-ending-style:duration-100 data-ending-style:ease-in");
function u({ align: u = "center", ariaLabel: d, children: f, className: p, inline: m = !1, label: h, passive: g = !1, popupClassName: _, positionerClassName: v, showHint: y = !0, side: b = "top", trigger: x, triggerClassName: S }) {
	let C = d ?? (typeof h == "string" ? h : void 0), w = m ? "span" : "div", T = x ?? /* @__PURE__ */ i(r, { className: "size-4" });
	return /* @__PURE__ */ a(w, {
		className: e(m ? "inline-flex" : "flex", "items-center gap-0.5", p),
		children: [f, y ? g ? /* @__PURE__ */ i(n, {
			content: h,
			popupProps: {
				"aria-label": C,
				className: _
			},
			positionerProps: {
				align: u,
				className: v,
				side: b
			},
			trigger: T,
			triggerProps: {
				"aria-label": C,
				className: e(c, S),
				render: /* @__PURE__ */ i("span", {
					"data-hint-trigger": "",
					className: "inline-flex"
				})
			}
		}) : /* @__PURE__ */ a(t.Root, { children: [/* @__PURE__ */ i(t.Trigger, {
			"aria-label": C,
			className: e(c, "cursor-pointer", S),
			closeDelay: s,
			"data-hint-trigger": "",
			delay: o,
			openOnHover: !0,
			children: T
		}), /* @__PURE__ */ i(t.Portal, { children: /* @__PURE__ */ i(t.Positioner, {
			align: u,
			className: v,
			side: b,
			children: /* @__PURE__ */ a(t.Popup, {
				"aria-label": C,
				className: e(l, _),
				children: [/* @__PURE__ */ i(t.Arrow, {}), h]
			})
		}) })] }) : null]
	});
}
//#endregion
export { u as Hint };
